import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia(query)
    setValue(mq.matches)
    const onChange = () => setValue(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return value
}
